import React from "react";
import LocationSearchingIcon from "@mui/icons-material/LocationSearching";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import BarChartIcon from "@mui/icons-material/BarChart";
import LayersIcon from "@mui/icons-material/Layers";
import { useParams } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";

// import { Link } from "react-router-dom";
import { ROLE } from "../utils/helper";
import keycloakService from "../keycloakService";
import {
  Grid,
  Link,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { styled } from "@mui/material/styles";

// const classes = {
//   removeUnderline: "removeUnderline",
//   colouredDiv: "colouredDiv",
//   colouredIcon: "colouredIcon",
//   colouredText: "colouredText",
//   notColouredDiv: "notColouredDiv",
//   notColouredIcon: "notColouredIcon",
//   notColouredText: "notColouredText",
//   logoutButton: "logoutButton",
// };
const classes = {
  removeUnderline: "removeUnderline",
  colouredDiv: "colouredDiv",
  colouredIcon: "colouredIcon",
  colouredText: "colouredText",
  notColouredDiv: "notColouredDiv",
  notColouredIcon: "notColouredIcon",
  notColouredText: "notColouredText",
  logoutButton: "logoutButton",
};
const Root = styled("div")(() => ({
  [`&.${classes.removeUnderline}`]: {
    textDecoration: "none",
  },
  [`& .${classes.colouredDiv}`]: {
    backgroundColor: "#083979",
    borderRadius: "15px",
    margin: "5px",
  },
  [`& .${classes.colouredIcon}`]: {
    color: "#FFFFFF",
  },
  [`& .${classes.colouredText}`]: {
    color: "#FFFFFF",
  },
  [`& .${classes.notColouredDiv}`]: {
    borderRadius: "15px",
    margin: "5px",
  },
  [`& .${classes.notColouredIcon}`]: {
    color: "#083979",
  },
  [`& .${classes.notColouredText}`]: {
    color: "#083979",
  },
  [`& .${classes.logoutButton}`]: {
    bottom: 30,
    position: "fixed",
    cursor: "auto",
  },
}));
export default function MinListItems({ open }) {
  const hasSuperAdmin = keycloakService.hasRole([ROLE.SuperAdmin]);
  // const history = useHistory();
  // const handleClick = (route) => {
  //   history.push(route);
  // };
  const params = useParams(":pageName");
  return (
    <Root>
      <Grid
        className={
          params.pageName == null ? classes.colouredDiv : classes.notColouredDiv
        }
      >
        <Link href={"/"} underline="none">
          <ListItem>
            <ListItemIcon>
              <DashboardIcon
                className={
                  params.pageName == null
                    ? classes.colouredIcon
                    : classes.notColouredIcon
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Dashboard"
              className={
                params.pageName == null
                  ? classes.colouredText
                  : classes.notColouredText
              }
            />
          </ListItem>
        </Link>
      </Grid>
      <Grid
        className={
          params.pageName == "route-point"
            ? classes.colouredDiv
            : classes.notColouredDiv
        }
      >
        <Link href={`/${"route-point"}`} underline="none">
          <ListItem>
            <ListItemIcon>
              <LocationSearchingIcon
                className={
                  params.pageName == "route-point"
                    ? classes.colouredIcon
                    : classes.notColouredIcon
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Adding Route Point"
              className={
                params.pageName == "route-point"
                  ? classes.colouredText
                  : classes.notColouredText
              }
            />
          </ListItem>
        </Link>
      </Grid>
      <Grid
        className={
          params.pageName == "vehicle"
            ? classes.colouredDiv
            : classes.notColouredDiv
        }
      >
        <Link href={`/add-vehicle/${"vehicle"}`} underline="none">
          <ListItem>
            <ListItemIcon>
              <LocalShippingIcon
                className={
                  params.pageName == "vehicle"
                    ? classes.colouredIcon
                    : classes.notColouredIcon
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Adding Vehicle"
              className={
                params.pageName == "vehicle"
                  ? classes.colouredText
                  : classes.notColouredText
              }
            />
          </ListItem>
        </Link>
      </Grid>
      <Grid
        className={
          params.pageName == "report"
            ? classes.colouredDiv
            : classes.notColouredDiv
        }
      >
        <Link href={`/schedule-report/${"report"}`} underline="none">
          <ListItem>
            <ListItemIcon>
              <BarChartIcon
                className={
                  params.pageName == "report"
                    ? classes.colouredIcon
                    : classes.notColouredIcon
                }
              />
            </ListItemIcon>
            <ListItemText
              primary="Reports"
              className={
                params.pageName == "report"
                  ? classes.colouredText
                  : classes.notColouredText
              }
            />
          </ListItem>
        </Link>
      </Grid>
      {!hasSuperAdmin && (
        <Grid
          className={
            params.pageName == "integrations"
              ? classes.colouredDiv
              : classes.notColouredDiv
          }
        >
          <Link href={`/temp/${"integrations"}`} underline="none">
            <ListItem>
              <ListItemIcon>
                <LayersIcon
                  className={
                    params.pageName == "integrations"
                      ? classes.colouredIcon
                      : classes.notColouredIcon
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary="Integrations"
                className={
                  params.pageName == "integrations"
                    ? classes.colouredText
                    : classes.notColouredText
                }
              />
            </ListItem>
          </Link>
        </Grid>
      )}
      {hasSuperAdmin && (
        <Grid
          className={
            params.pageName == "privilege"
              ? classes.colouredDiv
              : classes.notColouredDiv
          }
        >
          <Link href={`/add-privilege/${"privilege"}`} underline="none">
            <ListItem>
              <ListItemIcon>
                <LayersIcon
                  className={
                    params.pageName == "privilege"
                      ? classes.colouredIcon
                      : classes.notColouredIcon
                  }
                />
              </ListItemIcon>
              <ListItemText
                primary="Privilege"
                className={
                  params.pageName == "privilege"
                    ? classes.colouredText
                    : classes.notColouredText
                }
              />
            </ListItem>
          </Link>
        </Grid>
      )}
      <Link
        style={{ bottom: 30, position: "fixed" }}
        className={classes.removeUnderline}
        onClick={() => keycloakService.logout()}
      >
        <ListItem className="">
          <ListItemIcon>
            <ExitToAppIcon style={{ color: "red", cursor: "pointer" }} />
          </ListItemIcon>
          <ListItemText
            primary="Logout"
            style={{
              display: !open ? "none" : "",
              color: "red",
              cursor: "pointer",
            }}
          />
        </ListItem>
      </Link>
    </Root>
  );
}
